import { SC } from 'src/styles/theme';
import React from 'react';
import { StepNavigationStyled } from './StepNavigationStyled';
import { StepNavigationStyledOV } from './OV/StepNavigationStyled.OV';
import { StepNavigationStyledOVGB } from './OV/GB/StepNavigationStyled.OVGB';
import { StepNavigationStyledAP } from './AP/StepNavigationStyled.AP';
import { StepNavigationStyledAC } from './AC/StepNavigationStyled.AC';
import { StepNavigationStyledDS } from './DS/StepNavigationStyled.DS';
import { isBrandOV, isMarketGB, isBrandDS, isBrandAP, isBrandAC } from 'src/constants/main';

export interface IStepNavigation extends SC {}

const StepNavigation = (props: IStepNavigation) => {
    if (isBrandOV) return isMarketGB ? <StepNavigationStyledOVGB {...props} /> : <StepNavigationStyledOV {...props} />;
    if (isBrandAC) return <StepNavigationStyledAC {...props} />;
    if (isBrandAP) return <StepNavigationStyledAP {...props} />;
    if (isBrandDS) return <StepNavigationStyledDS {...props} />;
    return <StepNavigationStyled {...props} />;
};

export default StepNavigation;
